import { AxiosInstance } from "axios"
import { SupplierAccountWithHistory } from "./accountTypes"
import { SupportCreateSupplier } from "../../../../support/admin/entities/supplier/supplierTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

type FetchSupplierByIdParams = Readonly<{
    supplierId: number
}>

export async function fetchSupplierById(
    { supplierId }: FetchSupplierByIdParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupplierAccountWithHistory> {
    const url = `/suppliers/${supplierId}`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function updateAccountApi(
    { supplierId, supplier }: { supplierId: number; supplier: SupportCreateSupplier["entity"] },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/suppliers/${supplierId}`

    const response = await axios.post(
        url,
        {
            supplier,
        },
        {
            signal,
        },
    )

    return response.data
}
